import { RootState } from "../../store";

export const selectAppPage = (state: RootState) => state.appPage;